import React, { memo, useState } from 'react';
import { Box, Typography, Button } from '@material-ui/core';

const INITIAL_VISIBLE = 20;

const ChatTicketList = ({ tickets }) => {
  const [showAll, setShowAll] = useState(false);
  if (!tickets || tickets.length === 0) return null;

  const visible = showAll ? tickets : tickets.slice(0, INITIAL_VISIBLE);

  return (
    <Box sx={{ mt: 1, width: '100%' }}>
      {visible.map((t, idx) => (
        <Typography
          key={t.id ?? t.ticket_code ?? idx}
          variant="body2"
          sx={{ fontSize: '0.9rem', lineHeight: 1.6, wordBreak: 'break-word' }}
        >
          <Box component="span" sx={{ fontWeight: 700, mr: 0.75 }}>
            {t.ticket_code || `#${t.id}`}
          </Box>
          {t.name}
        </Typography>
      ))}
      {tickets.length > INITIAL_VISIBLE && (
        <Button
          size="small"
          onClick={() => setShowAll((v) => !v)}
          sx={{ mt: 0.5, ml: -0.75, textTransform: 'none', fontSize: '0.8rem' }}
        >
          {showAll ? 'Show less' : `Show all ${tickets.length}`}
        </Button>
      )}
    </Box>
  );
};

export default memo(ChatTicketList);
